const SubHeading = (props: { text: string }) => {
    return (
        <div className='mt-3 border-l-4 border-periwinkle-500 mb-8'>
            <p className='text-steel-100 ml-4 text-body'>{props.text}</p>
        </div>
    );
};

export default SubHeading;
